var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganisation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 1.66797H7.5C6.58083 1.66797 5.83333 2.41547 5.83333 3.33464V8.33464H4.16667C3.2475 8.33464 2.5 9.08214 2.5 10.0013V17.5013C2.5 17.7223 2.5878 17.9343 2.74408 18.0906C2.90036 18.2468 3.11232 18.3346 3.33333 18.3346H16.6667C16.8877 18.3346 17.0996 18.2468 17.2559 18.0906C17.4122 17.9343 17.5 17.7223 17.5 17.5013V3.33464C17.5 2.41547 16.7525 1.66797 15.8333 1.66797ZM4.16667 10.0013H9.16667V16.668H4.16667V10.0013ZM15.8333 16.668H10.8333V10.0013C10.8333 9.08214 10.0858 8.33464 9.16667 8.33464H7.5V3.33464H15.8333V16.668Z",
    fill: "#F8F8FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16683 5H10.8335V6.66667H9.16683V5ZM12.5002 5H14.1668V6.66667H12.5002V5ZM12.5002 8.35917H14.1668V10H12.5002V8.35917ZM12.5002 11.6667H14.1668V13.3333H12.5002V11.6667ZM5.8335 11.6675H7.50016V13.3342H5.8335V11.6675Z",
    fill: "#F8F8FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisation);
export default __webpack_public_path__ + "static/media/organisation.899deba22bd013f734d56b35c630d265.svg";
export { ForwardRef as ReactComponent };